<template>
  
  <div class="ui segment animated fadeIn">

    <form class="ui form">
      <div class="fields">                
        <div class="four wide field">
          <label class="form-label">Nome do Contato</label>
          <span>{{ customer.contact }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">E-mail do Contato</label>
          <span>{{ customer.mailContact }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">E-mail Financeiro</label>
          <span>{{ customer.mailFinance }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">E-mail Nota Fiscal</label>
          <span>{{ customer.email }}</span>
        </div>
      </div>     
    </form>

  </div>

</template>

<script>

  export default {    
    props: ["customer"],
  }

</script>

